import { ALL_TIME, NO_FILTER, isLiteral } from './date-filter-value.js';

/**
 * A scorecard tab's stored `date_range` and the shared date-range filter's time_range, both ways
 * (blink-superset-bundle.md, "The x-filters hosts"). The tab keeps the shape it always stored, so
 * saved tabs, ScorecardTab::settingsRules() and Convert to Report read it unchanged: a preset key,
 * a custom `{start, end}` with an INCLUSIVE end, or null. The filter writes Superset's literal with
 * an EXCLUSIVE end, and `No filter` for a clear.
 */
const DAY = /^\d{4}-\d{2}-\d{2}$/;

/** Calendar-day arithmetic on a `Y-m-d`, in UTC so no local offset or DST change can move it. */
function shiftDay(day, days) {
    const date = new Date(`${day}T00:00:00Z`);
    date.setUTCDate(date.getUTCDate() + days);
    return date.toISOString().slice(0, 10);
}

export function toTimeRange(setting) {
    if (typeof setting === 'string' && setting !== '') return setting;
    if (setting && DAY.test(setting.start ?? '') && DAY.test(setting.end ?? '')) {
        return `${setting.start} : ${shiftDay(setting.end, 1)}`;
    }
    return NO_FILTER;
}

export function fromTimeRange(value) {
    if (isLiteral(value)) {
        const [start, end] = value.split(' : ');
        return { start, end: shiftDay(end, -1) };
    }
    // The drawer offers no All Time: a clear and All Time both mean "no range", which a tab stores as null.
    if (typeof value !== 'string' || value === '' || value === NO_FILTER || value === ALL_TIME) return null;
    return value;
}
